import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


import "./PdfViewerPage.css";


const DailyNewsPdfView = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    // 1. Disable the sidebar entirely (removes Thumbnails/Bookmarks)
    sidebarTabs: (defaultTabs) => [],

    // 2. Explicitly define the toolbar to exclude Download and Print
    toolbarPlugin: {
      renderToolbar: (Toolbar) => (
        <Toolbar>
          {(slots) => {
            const {
              CurrentPageInput,
              GoToNextPage,
              GoToPreviousPage,
              ZoomIn,
              ZoomOut,
              ResetZoom,
              FullScreen,
              // IMPORTANT: We do NOT extract or use:
              // Download, Print, Open, Search, or ShowProperties
            } = slots;

            return (
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  width: '100%',
                  padding: '4px',
                  backgroundColor: '#f5f5f5',
                  borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                }}
              >
                <div style={{ padding: '0 2px' }}><GoToPreviousPage /></div>
                <div style={{ padding: '0 2px' }}><CurrentPageInput /></div>
                <div style={{ padding: '0 2px' }}><GoToNextPage /></div>

                {/* Spacer to push zoom controls to the right */}
                <div style={{ marginLeft: 'auto', padding: '0 2px' }}><ZoomOut /></div>
                <div style={{ padding: '0 2px' }}><ResetZoom /></div>
                <div style={{ padding: '0 2px' }}><ZoomIn /></div>
                <div style={{ padding: '0 2px' }}><FullScreen /></div>
              </div>
            );
          }}
        </Toolbar>
      ),
    },
  });

  const PageLoader = () => {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "#ffffff",
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{ width: "3.5rem", height: "3.5rem", color: "#f64a1aff" }}
        />
        <p className="mt-3 fw-semibold">Loading PDF...</p>
      </div>
    );
  };


  const { id } = useParams();
  const news_id = id;
  console.log("======================", news_id);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [pdfLoading, setPdfLoading] = useState(true);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [error, setError] = useState(null);

  /* ---------- FETCH PDF ---------- */
  useEffect(() => {
    if (!news_id) {
      setError("News ID missing");
      setLoading(false);
      return;
    }

    const fetchPdf = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}daily_news_pdf_url.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ news_id }),
        });

        const data = await res.json();

        // if (data.head.code === 200 && data.body?.pdf) {
        // setPdfUrl(data.view_url);
        setPdfUrl(data.view_url);
        setPdfLoading(true);
        // console.log();
        // } else {
        //   setError(data.head.msg || "PDF not found");
        // }
      } catch {
        setError("Error fetching PDF");
      } finally {
        setLoading(false);
      }
    };

    fetchPdf();
  }, [news_id]);


  useEffect(() => {
    if (!pdfUrl) return;

    const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" &&
            navigator.maxTouchPoints > 1);

    if (isIOS) {
        window.location.replace(pdfUrl);
    }
}, [pdfUrl]);

  useEffect(() => {
    if (!pdfLoading || !pdfUrl) return;

    const timer = setTimeout(() => {
        setPdfLoading(false);
        setError("Unable to load PDF");
    }, 15000);

    return () => clearTimeout(timer);
}, [pdfLoading, pdfUrl]);


  if (loading) return <PageLoader />;
  if (error) return <p className="text-center mt-5 text-danger">{error}</p>;
  console.log(pdfUrl);
  return (
    <div
      className="digital-library-page"
      onContextMenu={(e) => e.preventDefault()}
    >

      {(loading || pdfLoading) && <PageLoader />}
      {/* ---------- PDF VIEW ---------- */}
      <div className="pdf-wrapper mt-2" onContextMenu={(e) => e.preventDefault()}>

        {/* <iframe
         draggable={false}
  onDragStart={(e) => e.preventDefault()}
          key={page}
          ref={iframeRef}
          src={`${pdfUrl}#page=${page}&toolbar=0&navpanes=0&scrollbar=0`}
          title="Magazine Reader"
          className="pdf-iframe"
          style={{
            transform: `scale(${zoom})`,
            transformOrigin: "top center",
          }}
        /> */}

        <div style={{ height: '700px' }}>
          {/* <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js`}> */}
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
            <Viewer
              fileUrl={pdfUrl}
              plugins={[defaultLayoutPluginInstance]}
              onDocumentLoad={() => setPdfLoading(false)}
              onDocumentLoadFail={(e) => {
                console.log("PDF Load Error", e);
                setPdfLoading(false);
                setError("Unable to load PDF");
              }}
            />
          </Worker>

        </div>

      </div>
    </div>
  );
};

export default DailyNewsPdfView;
